// A PARTNER-PORTÁL hozzáférés-lista query-kulcsa — külön, apró modulban.
//
// MIÉRT NEM EGY KOMPONENS MELLETT: korábban a (azóta megszűnt) „Partner-portál hozzáférés" szekció
// exportálta. Azt a szakaszt kivezettük — a szerep a kapcsolattartó-sidebarban állítható, a fiók-lapon pedig
// a Kapcsolattartók szekció badge-e mutatja —, a kulcsra viszont továbbra is két helyen szükség van (a
// sidebar olvassa és invalidálja, a szekció pedig a badge-hez olvassa). Egy komponensből exportált
// query-kulcs ráadásul azt a komponenst teszi a cache szerződésének gazdájává, ami törlésnél épp ezt a
// csapdát hozza elő.
export const portalAccessKeys = {
  list: (accountId: string): string[] => ['portal-access', accountId],
};
